export default {
    getManager:    state => state.manager,
    getPopupState: state => state.popup,
};
